import { useState, useEffect, forwardRef } from "react";
import CreateNewModal from "./shorts-series/create_content_modal";
import { AxiosInstance } from "../../common/Loader/axios.config";
import { MdOutlineLibraryAdd } from "react-icons/md";
import { FaUpload } from "react-icons/fa6";
import UploadVideoModal from "./shorts-series/upload_video";
import EditVideoModal from "./shorts-series/edit_video_modal";

const ShortsSeriesUpload = forwardRef((props, ref) => {
    const { setUploadStatus, setProgress } = props;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
    const [isEditVideoModalOpen, setIsEditVideoModalOpen] = useState(false);
    const [content, setContent] = useState([]);
    const [selectedSeries, setSelectedSeries] = useState(null);
    const [selectedVideo, setSelectedVideo] = useState(null);

    useEffect(() => {
        AxiosInstance.get("/new-content")
            .then((response) => {
                const allContent = response.data.message;

                const sortedContent = allContent.sort((a, b) => {
                    return (
                        new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
                    );
                });

                setContent(sortedContent);
            })
            .catch((error) => {
                console.error("Error fetching content:", error);
            });
    }, []);

    return (
        <div className="w-full flex flex-col items-center">
            <div className="w-full flex items-center justify-between my-4">
                {/* Show back button if a series is selected */}
                {selectedSeries ? (
                    <button
                        className="bg-gray-500 text-white py-2 px-4 rounded-full"
                        onClick={() => setSelectedSeries(null)}
                    >
                        Back
                    </button>
                ) : (
                    <div></div>
                )}

                {selectedSeries ? (
                    <button
                        className="flex items-center gap-x-1 bg-primary text-white py-2 px-4 rounded-full hover:scale-105 duration-200"
                        onClick={() => setIsUploadModalOpen(true)}
                    >
                        <FaUpload />
                        <p>Upload</p>
                    </button>
                ) : (
                    <button
                        className="flex items-center gap-x-1 bg-primary text-white py-2 px-4 rounded-full hover:scale-105 duration-200"
                        onClick={() => setIsModalOpen(true)}
                    >
                        <MdOutlineLibraryAdd size={24} />
                        <p className="font-bold">Create New</p>
                    </button>
                )}
            </div>

            {/* Show either the list of series or the videos inside a series */}
            {selectedSeries ? (
                <div className="w-full">
                    <h2 className="text-xl text-white font-bold text-black">{selectedSeries.title}</h2>
                    <p className="text-white mb-4">{selectedSeries.description}</p>
                    <div className="grid grid-cols-3 gap-4">
                        {selectedSeries.video_content.map(video => (
                            <div
                                key={video._id}
                                className="relative bg-white rounded shadow p-4 transition-transform transform hover:scale-105 hover:shadow-lg"
                            >
                                {/* Use the selected series thumbnail instead of video.thumbnail */}
                                <img src={selectedSeries.thumb_nail} alt={selectedSeries.title} className="w-full h-auto rounded" />
                                <h3 className="text-black text-md font-semibold">{video.title}</h3>
                                <p className="text-black text-sm">Price: MWK {video.price}</p>
                                <p className="text-black text-sm">Views: {video.views}</p>

                                <button
                                    className="mt-2 bg-primary text-white py-2 px-4 rounded-md"
                                    onClick={() => {
                                        setSelectedVideo(video); 
                                        setIsEditVideoModalOpen(true);
                                    }}
                                >
                                    Edit
                                </button>
                            </div>
                        ))}
                    </div>

                </div>
            ) : (
                <div className="grid grid-cols-3 gap-4">
                    {content.map(series => (
                        <div
                            key={series._id}
                            className="relative bg-white rounded shadow p-4 transition-transform transform hover:scale-105 hover:shadow-lg cursor-pointer"
                            onClick={() => setSelectedSeries(series)}
                        >
                            <img src={series.thumb_nail} alt={series.title} className="w-full h-auto rounded" />
                            <h3 className="text-black text-lg font-semibold">{series.title}</h3>
                            <p className="text-black text-sm">Videos: {series.video_content.length}</p>
                            <p className="text-black text-sm">Price: MWK {series.price}</p>
                            <p className="text-black text-sm">
                                Created: {new Date(series.created_at).toLocaleDateString("en-US", {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric"
                                })}
                            </p>

                        </div>
                    ))}
                </div>
            )}

            <CreateNewModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

            {isUploadModalOpen && (
                <UploadVideoModal isOpen={isUploadModalOpen} onClose={() => setIsUploadModalOpen(false)} selectedSeries={selectedSeries} />
            )}

            {isEditVideoModalOpen && (
                <EditVideoModal isOpen={isEditVideoModalOpen} onClose={() => setIsEditVideoModalOpen(false)} selectedVideo={selectedVideo} />
            )}
            
        </div>
    );
});

export default ShortsSeriesUpload;
